import React from 'react';
import { useNavigate } from 'react-router-dom';

import Hero from '../components/ui/Hero';

const ThankYou: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Hero
        title='БЛАГОДАРЯ'
        subtitle='ЗА ВАШАТА ПОРЪЧКА'
        text='Вашата поръчка е приета успешно. Ще се свържем с вас скоро.'
        fontSize={42}
        buttonText='Върни се на началната страница'
        onButtonClick={() => navigate('/')}
      />
    </>
  );
};
export default ThankYou;
